import { observable } from 'mobx';
import { ApiService } from '../services/api';
import { Resource } from '../services/json-api/Resource';
import { VoiceLogMoment } from './voicelogs/VoiceLogMoment';
import { RegisteredCall } from './RegisteredCall';
import {ResponseStatus} from "../services/api/response/ResponseStatus";
import {JsonDocument} from "../services/json-api/JsonDocument";
import {JsonDocumentInterface} from "../services/json-api/document";
import {VoiceLog} from "./voicelogs/VoiceLog";

export class VoiceLogStore {
    @observable private _voiceLog?: JsonDocument<VoiceLog>;
    @observable private callId?: JsonDocument<VoiceLog>;

    private api: ApiService;

    public constructor() {
        this.api = new ApiService();
    }

    public get voiceLog(): JsonDocument<VoiceLog> | undefined {
        return this._voiceLog;
    }

    public async startVoicelog(call: Resource<RegisteredCall>): Promise<void> {
        if (!this._voiceLog) {
            const response = await this.api.post(
                'api/v2/call-registration-voice-log-moments',
                Resource.makeCreateObject<VoiceLogMoment>('call-registration-voice-log-moments', {
                    call_registration_id: call.getId(),
                })
            );
            if (response.getStatus() === ResponseStatus.CREATED) {
                this._voiceLog = new JsonDocument<VoiceLog>(
                    response.getData() as JsonDocumentInterface<VoiceLog>
                );
            }
        }
    }

    public async endVoiceLog(call: Resource<RegisteredCall>): Promise<void> {
        if (this._voiceLog) {
            const id = this._voiceLog?.getResources()[0].getId();
            const response = await this.api.put(
                `api/v2/call-registration-voice-log-moments/${id}`,
                this._voiceLog?.getResources()[0].makeUpdateObject({
                    call_registration_id: call.getId()
                })
            )
            if (response.getStatus() === ResponseStatus.OK) {
                this._voiceLog = undefined;
            }
        }
    }
}

export const voiceLogStore = new VoiceLogStore();
